module.exports = __webpack_public_path__ + "img/Genuss-Cafe-Pralinen-HV.4116e4d3.jpg";